import { configureStore, Tuple } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'company', 'me', 'user'], // Solo persistir estos reducers
};

const persistedReducer = persistReducer(persistConfig, reducers());

// middleware: () => new Tuple(logger),
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.REACT_APP_NODE_ENV !== 'production',
});
const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export { store, persistor };
